import { CriteriaOperator } from '@shared/models/types/types.generated';

const equalityOperators = [
  CriteriaOperator.Equals,
  CriteriaOperator.NotEquals,
  CriteriaOperator.Greater,
  CriteriaOperator.GreaterEqual,
  CriteriaOperator.Less,
  CriteriaOperator.LessEqual,
];
const multiValueOperators = [CriteriaOperator.In, CriteriaOperator.NotIn];
const fuzzyOperators = [CriteriaOperator.Like, CriteriaOperator.NotLike];
const binaryOperators = [...equalityOperators, ...multiValueOperators, ...fuzzyOperators];

/**
 * Maps each {@link CriteriaOperator} to an array of operators that can be transitioned to
 * without losing the current filter value (i.e., value-preserving transitions).
 *
 * - Binary operators (e.g., Equals, NotEquals, Greater, etc.) can transition among each other.
 * - Some operators (e.g., In, NotIn, Like, NotLike) can only transition to their logical counterpart.
 * - Null-check operators (IsNull, NotNull) do not allow value-preserving transitions.
 */
export const valuePreservingTransitions: Record<CriteriaOperator, CriteriaOperator[]> = {
  [CriteriaOperator.Equals]: binaryOperators,
  [CriteriaOperator.NotEquals]: binaryOperators,
  [CriteriaOperator.Greater]: binaryOperators,
  [CriteriaOperator.GreaterEqual]: binaryOperators,
  [CriteriaOperator.Less]: binaryOperators,
  [CriteriaOperator.LessEqual]: binaryOperators,
  [CriteriaOperator.In]: [CriteriaOperator.NotIn],
  [CriteriaOperator.NotIn]: [CriteriaOperator.In],
  [CriteriaOperator.Like]: [CriteriaOperator.NotLike],
  [CriteriaOperator.NotLike]: [CriteriaOperator.Like],
  [CriteriaOperator.IsNull]: [],
  [CriteriaOperator.NotNull]: [],
  [CriteriaOperator.HasSubfilter]: [CriteriaOperator.NotHasSubfilter],
  [CriteriaOperator.NotHasSubfilter]: [CriteriaOperator.HasSubfilter],
};
